import { removeClass, addClass } from '@utils/domUtils';

export default class SubscriptionSelector {
  static selectorString() {
    return '.SubscriptionSelector';
  }

  render(node, props) {
    this.selectedPriceTable = document.querySelector('.selected-price-table');

    this.prices = [...node.querySelectorAll('[name="priceId"]')].map(element => {
      element.radio = element;
      element.priceId = element.radio.getAttribute('value');
      element.addEventListener('change', this.changedSubscriptionInterval.bind(this));
      return element;
    });

    if (this.prices.length === 1) {
      this.selectSubscriptionInterval(this.prices[0]);
    }

    this.updateSelectedPriceTable();
  }

  changedSubscriptionInterval(event) {
    event.preventDefault();
    this.selectSubscriptionInterval(event.currentTarget);
  }

  selectSubscriptionInterval(interval) {
    const radio = interval.radio;

    this.prices
      .filter(element => element !== interval)
      .forEach(element => {
        element.radio.checked = false;
      });

    radio.checked = true;

    this.updateSelectedPriceTable();
  }

  updateSelectedPriceTable() {
    const interval = this.prices.find(element => !!element.radio.checked);

    if (!interval) {
      return;
    }

    if (this.selectedPriceTable) {
      this.selectedPriceTable.querySelectorAll('.price-info').forEach(element => {
        if (element.getAttribute('data-price-id') === interval.priceId) {
          removeClass(element, 'd-none');
        } else {
          addClass(element, 'd-none');
        }
      });

      removeClass(this.selectedPriceTable, 'd-none');
    }
  }
}
